import cardio from "./cardiograma.svg"
import strenght from "./fuerte.svg"
import flexibility from "./padmasana.svg"
import agility from "./superheroe.svg"
import meditationMan from "./yoga.svg"
import meditationWoman from "./yoga (1).svg"
import speed from "./funcionamiento.svg"
import instagram from './instagram.svg'
import gamer from './gamer.svg'
import underconst from './underconst.svg'

const icons = {
    cardio,
    strenght,
    flexibility,
    agility,
    meditationMan,
    meditationWoman,
    speed,
    instagram,
    gamer,
    underconst
}

export default icons
